import { useEffect } from 'react'

const PENDO_BASE_ID = 'pendo-base'
export const UPGRADE_CTA_QUERY_SELECTOR = '[aria-label^=ccaas-upgrade]'

interface ObserverParams {
  onCtaClick: (params: { campaignId: string }) => void
  upgradeCtaSelector: string
}
export const usePendoModalMutationObserver = ({ upgradeCtaSelector, onCtaClick }: ObserverParams) => {
  useEffect(() => {
    let $upgradeCta: Element | null = null
    let upgradeCtaCampaignId
    let upgradeCtaCallBack: () => any

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && (node as Element).id === PENDO_BASE_ID) {
            $upgradeCta = (node as Element).querySelector(upgradeCtaSelector)

            if ($upgradeCta) {
              upgradeCtaCampaignId = $upgradeCta?.getAttribute('aria-label')?.split(':')[1]

              upgradeCtaCallBack = () => onCtaClick({ campaignId: upgradeCtaCampaignId })

              $upgradeCta?.addEventListener('click', upgradeCtaCallBack)
            }
          }
        })
      })
    })

    observer.observe(document.body, {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true,
    })

    return () => {
      observer.disconnect()
      $upgradeCta && upgradeCtaCampaignId && $upgradeCta.removeEventListener('click', upgradeCtaCallBack)
    }
  }, [onCtaClick, upgradeCtaSelector])
}
